export enum BUTTON_VARIANTS {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  SECONDARYDESTRUCTIVE = 'secondary-destructive',
  GHOST = 'ghost',
  GHOSTINFO = 'ghost-info',
  GHOSTSUCCESS = 'ghost-success',
  GHOSTWARNING = 'ghost-warning',
  GHOSTERROR = 'ghost-error',
  GHOSTINVERTED = 'ghost-inverted',
  DESTRUCTIVE = 'destructive',
  TEXT = 'text',
}

export enum BUTTON_SIZES {
  LARGE = 'large',
  MEDIUM = 'medium',
  SMALL = 'small',
}
